<header>
  <h1>
    User Admin
    <button
      [routerLink]="['/user/new']"
      [queryParams]="{role: 'user-admin'}"
      color="primary"
      mat-mini-fab
      matTooltip="Create page."
      >
      <mat-icon>add</mat-icon>
    </button>
  </h1>
  <search-text (search)="setSearch($event)"></search-text>
</header>
<section class="filters">
  <button
    mat-stroked-button
    (click)="dataCleanse()"
    color="primary"
    matTooltip="User data cleanse."
    >
    <mat-icon>cleaning_services</mat-icon>
    Cleanse
  </button>
  <button
    mat-stroked-button
    (click)="exportUsers()"
    color="primary"
    matTooltip="Export User data."
    >
    <div class="user-export">
      @if (exporting !== 'users') {
        <mat-icon>file_download</mat-icon>
      }
      @if (exporting === 'users') {
        <mat-spinner diameter="24"></mat-spinner>
      }
      Export Users
    </div>
  </button>
  <button
    mat-stroked-button
    (click)="clubsExport()"
    color="primary"
    matTooltip="Export User data."
    >
    @if (exporting !== 'clubs') {
      <mat-icon>file_download</mat-icon>
    }
    @if (exporting === 'clubs') {
      <mat-spinner diameter="24"></mat-spinner>
    }
    Export Clubs
  </button>
</section>
<section class="filters">
  <mat-button-toggle-group
    #typeFilter="matButtonToggleGroup"
    (change)="setType(typeFilter.value)"
    [value]="defaultType"
    >
    <mat-button-toggle disabled value="*">Type:</mat-button-toggle>
    @for (toggle of toggles; track toggle) {
      <mat-button-toggle [value]="toggle.value">
        <mat-icon>{{toggle.icon}}</mat-icon>
        {{toggle.label}}
      </mat-button-toggle>
    }
  </mat-button-toggle-group>
</section>
<section class="users">
  @if (loading) {
    <mat-card class="loading">
      <mat-card-content>
        <mat-icon class="loading">autorenew</mat-icon>
        Loading&hellip;
      </mat-card-content>
    </mat-card>
  }
  @if (!loading) {
    @if (!Users?.length) {
      <mat-card class="no-results">
        <mat-card-content>
          <mat-icon>sentiment_dissatisfied</mat-icon>
          No partners found.
        </mat-card-content>
      </mat-card>
    }
    @if (!!Users.length) {
      <table mat-table [dataSource]="DataSource" class="user">
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let row">
            @if (row.features['current-working-partner']) {
              <mat-icon
                >person</mat-icon
                >
              }
              @if (row.features['juno']) {
                <mat-icon>elderly</mat-icon>
              }
              @if (row.features['bir']) {
                <mat-icon>person_outline</mat-icon>
              }
              @if (row.features['obir'] || row.features['leavers'] || row.features['poss']) {
                <mat-icon
                  >person_off</mat-icon
                  >
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="first_name">
              <th mat-header-cell *matHeaderCellDef>First Name</th>
              <td mat-cell *matCellDef="let row">{{row.first_name}}</td>
            </ng-container>
            <ng-container matColumnDef="last_name">
              <th mat-header-cell *matHeaderCellDef>Surname</th>
              <td mat-cell *matCellDef="let row">{{row.last_name}}</td>
            </ng-container>
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef>Email</th>
              <td mat-cell *matCellDef="let row">{{row.email}}</td>
            </ng-container>
            <ng-container matColumnDef="employee_number">
              <th mat-header-cell *matHeaderCellDef>Employee No.</th>
              <td mat-cell *matCellDef="let row">{{row.employee_number}}</td>
            </ng-container>
            <ng-container matColumnDef="branch_number">
              <th mat-header-cell *matHeaderCellDef>Branch No.</th>
              <td mat-cell *matCellDef="let row">{{row.branch_number}}</td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Actions</th>
              <td mat-cell *matCellDef="let row" class="actions">
                <button
                  [routerLink]="['/user', row.id]"
                  [queryParams]="{role: 'user-admin'}"
                  mat-icon-button
                  matTooltip="Edit partner details"
                  >
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  (click)="resetUserPassword(row)"
                  mat-icon-button
                  matTooltip="Reset partner password."
                  >
                  <mat-icon>lock</mat-icon>
                </button>
                <button
                  (click)="generateUserPassword(row)"
                  mat-icon-button
                  matTooltip="Generate partner password."
                  >
                  <mat-icon>autorenew</mat-icon>
                </button>
                @if (row.purchases === 0) {
                  <button
                    (click)="deleteUser(row)"
                    mat-icon-button
                    matTooltip="Delete user."
                    >
                    <mat-icon>delete</mat-icon>
                  </button>
                }
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          @if (PageEvent) {
            <mat-paginator
              (page)="DataSource.loadWithPageEvent($event)"
              [length]="PageEvent.length"
              [pageIndex]="PageEvent.pageIndex"
              [pageSize]="PageEvent.pageSize"
            ></mat-paginator>
          }
        }
      }
    </section>
